import {
  Drawer,
  List,
  ListItemText as MUIListItemText,
  Toolbar,
  Typography,
} from '@mui/material';
import { ListItemTextProps as MUIListItemTextProps } from '@mui/material/ListItemText';
import styled from 'styled-components';

const TitleToolbar = styled(Toolbar)`
  && {
    height: ${({ theme }) => theme.shape.appbarHeight}px;
    min-height: ${({ theme }) => theme.shape.appbarHeight}px;
    padding-left: ${({ theme }) => theme.spacing(7)};
  }
`;

const StyledDrawer = styled(Drawer)`
  && {
    & .MuiDrawer-paper {
      box-sizing: border-box;
      border: none;
      width: ${({ theme }) => theme.shape.drawerWidth}px;
      background-color: ${({ theme }) => theme.palette.backdrop.main};
      padding-bottom: ${({ theme }) => theme.spacing(8)};
      border-radius: 0 64px 64px 0;
      background-image: none;
    }
  }
`;

const ScrollableContainer = styled.div`
  overflow: hidden;
  :hover {
    overflow: auto;
  }
`;

const ListHeaderText = styled(MUIListItemText)`
  && {
    & .MuiListItemText-primary {
      font-weight: bold;
      color: ${({ theme }) => theme.palette.highlight.main}
    }
  }
`;

interface ListItemTextProps extends MUIListItemTextProps {
  selected: boolean,
}

const ListItemText = styled(MUIListItemText)<ListItemTextProps>`
  && {
    & .MuiListItemText-primary {
      font-weight: ${({ selected }) => selected && 'bold'};
    }
  }
`;

const StyledList = styled(List)`
  && {
      margin: 0 ${({ theme }) => theme.spacing(1)};
      border-radius: ${({ theme }) => theme.shape.borderRadius}px 0;
    & .Mui-selected {
      color: ${({ theme }) => theme.palette.darkPrimary.main};
      background-color: ${({ theme }) => theme.palette.primary.light}80;
      &:hover {
        background-color: ${({ theme }) => theme.palette.primary.light}80;
      }
    }
  }
`;

const GradientEmphasis = styled.span`
  font-weight: bold;
  background: -webkit-linear-gradient(45deg, ${({ theme }) => theme.palette.primary.main}, ${({ theme }) => theme.palette.info.main});
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
`;

const Title = styled(Typography)`
  && {
    pointer-events: all;
    margin-left: ${({ theme }) => theme.spacing(3)};
    color: ${({ theme }) => theme.palette.darkPrimary.dark};
    user-select: none;
    font-size: small;
    cursor: pointer;
  }
`;

export { StyledList,
  GradientEmphasis,
  Title,
  StyledDrawer,
  TitleToolbar,
  ScrollableContainer,
  ListItemText,
  ListHeaderText };
